import { Injectable, signal } from '@angular/core';
import { FlowState, PostOtpStep } from '../types/flow.types';

@Injectable({ providedIn: 'root' })
export class FlowService {
  private state = signal<FlowState>('idle');
  private postOtpStep = signal<PostOtpStep>(null);

  private toRevisionNonce = signal<string | null>(null);
  private toFormNonce = signal<string | null>(null);

  current = () => this.state();
  getPostOtpStep = () => this.postOtpStep();
  canEnterVerify = () => this.state() === 'identified' || this.state() === 'otpVerified';
  canEnterNuevoBeneficiarioBase = () => this.state() === 'otpVerified';
  canEnterRevisionBase = () => this.state() === 'otpVerified';
  shouldConfirmExit = () => this.state() === 'otpVerified';

  public completeIdentify(): void {
    this.state.set('identified');
  }

  public completeOtp(): void {
    this.state.set('otpVerified');
  }

  public completeRegistration(): void {
    this.state.set('completed');
    this.postOtpStep.set(null);
    this.toRevisionNonce.set(null);
    this.toFormNonce.set(null);
  }

  /**
   * @description Sets proper step after identification and email verification.
   * @param {PostOtpStep} step - Initialized step.
   */
  public setPostOtpStep(step: PostOtpStep): void {
    this.postOtpStep.set(step);
  }

  /**
   * @description Allows pass to summary from new beneficiary form.
   */
  public allowSummaryOnce(): void {
    this.toRevisionNonce.set(this.uuid());
  }

  /**
   * @description Allows pass to new beneficiary form on adding with review button.
   */
  public allowFormOnce(): void {
    this.toFormNonce.set(this.uuid());
  }

  
  public consumeSummaryNonce(): boolean {
    const ok = !!this.toRevisionNonce();
    this.toRevisionNonce.set(null);

    return ok;
  }

  public consumeFormNonce(): boolean {
    const ok = !!this.toFormNonce();
    this.toFormNonce.set(null);

    return ok;
  }

  resetAll() {
    this.state.set('idle');
    this.postOtpStep.set(null);
    this.toRevisionNonce.set(null);
    this.toFormNonce.set(null);
  }

  /** Para redirecciones cuando teclean URL indebidas */
  lastAllowedChildPath(): 'identificacion' | 'verificar-correo' | 'nuevo-beneficiario' | 'revision' {
    const state = this.state();
    if (state === 'idle') return 'identificacion';
    if (state === 'identified') return 'verificar-correo';
    if (state === 'completed') return 'identificacion';
    // post-OTP: devolver el último subpaso visitado
    return this.postOtpStep() === 'summary' ? 'revision' : 'nuevo-beneficiario';
  }

  // ===== util
  private uuid(): string {
    return (globalThis.crypto?.randomUUID?.() ?? Math.random().toString(36).slice(2));
  }
}
